export default __webpack_public_path__ + "static/media/camping&Hunting.a35f358b.png";